export default __webpack_public_path__ + "static/media/a015-1.1d4c204c.svg";